import React from 'react';
import { KPIContainer, KPIContainerMobile } from './styles';
import { Props } from './types';
import CardAC from './CardAC';
import CardEaInterno from './CardEaInterno';
import CardEaExterno from './CardEaExterno';
import CardSA from './CardSA';
import CardSE from './CardSE';
import { useWindowSize } from '../../../../../hook/useWindowSize';
import { ApplicationState } from '../../../../../store';
import { useSelector } from 'react-redux';

const KPI: React.FC<Props> = () => {
  const { width }: any = useWindowSize();
  const cddAtivo = useSelector((state: ApplicationState) => state.auth?.cddAtivo?.codCdd) as number;
  const iscricaoAtiva = useSelector((state: ApplicationState) => state.auth?.inscricaoAtiva);

  return width > 768 ? (
    <KPIContainer>
      <CardAC cdd={cddAtivo} inscricao={iscricaoAtiva} />
      <CardSA cdd={cddAtivo} inscricao={iscricaoAtiva} />
      <CardSE cdd={cddAtivo} inscricao={iscricaoAtiva} />

      <CardEaInterno cdd={cddAtivo} inscricao={iscricaoAtiva} />
      <CardEaExterno cdd={cddAtivo} inscricao={iscricaoAtiva} />
    </KPIContainer>
  ) : (
    <KPIContainerMobile></KPIContainerMobile>
  );
};

export default KPI;
